import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import AXIOS from "../../../helpers/api";
import { BASE_API } from "../../../helpers/apiUrl";
import { AUTH_SAVE } from "../../../helpers/config";
import { toast } from "../../../helpers/toast";
import {
  AuthUser,
  CommonOthers,
  ErrorMessage,
  LoginActionType,
  LoginData,
  PostRequest,
} from "../../../types/redux";

// login user
export const loginUserAsync = createAsyncThunk<
  LoginActionType<AuthUser>,
  PostRequest<LoginData, CommonOthers>,
  {
    rejectValue: ErrorMessage;
  }
>(
  "login/npLogin",
  async ({ data, others: { reRender } }, { rejectWithValue }) => {
    try {
      const loginData = await AXIOS.post(BASE_API.login, data);

      const responseData = {
        token: loginData?.data?.token,
        data: loginData?.data?.UserLogin?.data,
        // TODO: default NP
        // siteRole: data?.loginRole,
        siteRole: undefined as undefined | string,
      };

      const loginRole = loginData?.data?.UserLogin?.data?.role;

      console.log(data?.loginRole, loginData?.data?.UserLogin?.data?.role);

      if (
        (data?.loginRole === "NP" || data?.loginRole === "SA") &&
        loginRole === "edatco"
      ) {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "REGIONAL" && loginRole === "region") {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "FINANCE" && loginRole === "finance") {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "VENDOR" && loginRole === "vendor") {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "CLUSTER" && loginRole === "cluster") {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "ENERGYOPS" && loginRole === "energyOps") {
        responseData.siteRole = data?.loginRole;
      } else if (
        data?.loginRole === "DIRECTOROPS" &&
        loginRole === "directorOps"
      ) {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "GROPS" && loginRole === "gr") {
        responseData.siteRole = data?.loginRole;
      } else if (data?.loginRole === "SCM" && loginRole === "scm") {
        responseData.siteRole = data?.loginRole;
      } else {
        throw Error("Unauthorize");
      }

      if (responseData?.token && responseData?.data?.email) {
        AXIOS.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${responseData?.token}`;
        AXIOS.defaults.headers.common["ngrok-skip-browser-warning"] = true;

        localStorage.setItem(`${AUTH_SAVE}`, JSON.stringify(responseData));
      }

      reRender(true);
      toast("success", "Login successfully");

      return responseData as LoginActionType<AuthUser>;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      toast("error", error?.message || "Login fail");
      return rejectWithValue(error);
    }
  }
);

// forgot password user
// export const forgotPasswordAsync = createAsyncThunk<
//   AuthUser,
//   PostRequest<any, CommonOthers>,
//   {
//     rejectValue: ErrorMessage;
//   }
// >(
//   "login/forgotPassword",
//   async ({ data, others: { reRender } }, { rejectWithValue }) => {
//     try {
//       const loginData = await AXIOS.post(BASE_API.forgotPassword, data);

//       if (loginData?.data?.token && loginData?.data?.email) {
//         AXIOS.defaults.headers.common[
//           "Authorization"
//         ] = `Bearer ${loginData?.data?.token}`;

//         localStorage.setItem(`${AUTH_SAVE}`, JSON.stringify(loginData?.data));

//         reRender(true);
//       } else if (loginData) {
//         reRender(false);
//       }

//       return loginData.data as AuthUser;
//     } catch (err) {
//       const errors = err as AxiosError;
//       const error = errors.response?.data as ErrorMessage;
//       return rejectWithValue(error);
//     }
//   }
// );

export const getMeAsync = createAsyncThunk<
  any,
  any,
  {
    rejectValue: ErrorMessage;
  }
>("login/getGetMe", async ({ token }, { rejectWithValue }) => {
  try {
    const data = await AXIOS.get(BASE_API.getMe, {
      headers: {
        Authorization: `Bearer ${token}`,
        "ngrok-skip-browser-warning": true,
      },
    });

    const getData = data.data?.getData;

    const responseData = {
      siteRole: "",
      data: getData,
      token,
    };

    if (getData?.role === "edatco") {
      responseData.siteRole = "NP";
    } else if (getData?.role === "region") {
      responseData.siteRole = "REGIONAL";
    } else if (getData?.role === "finance") {
      responseData.siteRole = "FINANCE";
    } else if (getData?.role === "vendor") {
      responseData.siteRole = "VENDOR";
    } else if (getData?.role === "cluster") {
      responseData.siteRole = "CLUSTER";
    } else if (getData?.role === "energyOps") {
      responseData.siteRole = "ENERGYOPS";
    } else if (getData?.role === "directorOps") {
      responseData.siteRole = "DIRECTOROPS";
    } else if (getData?.role === "gr") {
      responseData.siteRole = "GROPS";
    } else if (getData?.role === "scm") {
      responseData.siteRole = "SCM";
    } else {
      throw Error("Unauthorize");
    }

    if (responseData?.token && responseData?.data?.email) {
      AXIOS.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${responseData?.token}`;
      AXIOS.defaults.headers.common["ngrok-skip-browser-warning"] = true;

      localStorage.setItem(`${AUTH_SAVE}`, JSON.stringify(responseData));
    }

    return responseData as any;
  } catch (err) {
    const errors = err as AxiosError;
    const error = errors.response?.data as ErrorMessage;
    toast("error", error?.message || "Get me fail");
    return rejectWithValue(error);
  }
});

export const addMobileTokenAsync = createAsyncThunk<null, any>(
  "login/addMobileToken",
  async ({ data }, { rejectWithValue }) => {
    console.log(data);
    try {
      await AXIOS.post(
        BASE_API.addMobileToken,
        {
          mobileToken: data?.mobileToken,
          isPG: false,
        },
        {
          headers: {
            Authorization: `Bearer ${data?.token}`,
            "ngrok-skip-browser-warning": true,
          },
        }
      );

      return null;
    } catch (err) {
      const errors = err as AxiosError;
      const error = errors.response?.data as ErrorMessage;
      // toast("error", error?.message || "Please turn on notifications");
      toast("error", "Please turn on notifications");
      return rejectWithValue(error);
    }
  }
);
